import React from 'react';
import '../App.css';
import WelComeLayer from '../components/WelcomeLayer'
import 'bootstrap/dist/css/bootstrap.min.css';
import InscriptionFormFunCol from "../components/InscriptionFormFunCol";
import {IMAGES, MESSAGES} from "../util/Messages";


export default class InscriptionFunColApp extends React.Component {
  render() {
    return (
      <>
        <WelComeLayer logo={IMAGES.funcol} footer="" message={MESSAGES.WELCOME_MESSAGE_FUNCOL}/>
        <InscriptionFormFunCol />
      </>
    );
  }
}
